<div [class]="classes">
  <div class="collapsible-header" (click)="onToggle()" [attr.data-testid]="'collapsible-header-' + dataTestId">
    <div class="collapsible-title">
      <ng-content #titleBlock select="[slot=title]"></ng-content>
      @if (!titleBlock) {
        <div>{{this.title}}</div>
      }
    </div>
    <app-spark-icon class="collapsible-header-collapsed-icon" [icon]="collapsedIcon" [size]="'24'"></app-spark-icon>
    <app-spark-icon class="collapsible-header-open-icon" [icon]="openIcon" [size]="'24'"></app-spark-icon>
  </div>
  <div class="collapsible-content">
    <ng-content></ng-content>
  </div>
</div>